export enum TipoDocumentoCartorioEnum {

  ATO = "Ato",
  PAGINA = "Página",
  SELO = "Selo",

}
